import React, { PropsWithChildren } from "react";

import "../global.css";

export function Layout({ children }: PropsWithChildren) {
  return <div className="layout">{children}</div>;
}
